import React, { useState } from 'react'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import dayjs from 'dayjs'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import CustomSvgIcon from '@/components/icons/builder/CustomSvgIcon'
import calendarIcon from '@/components/icons/builder/paths/calendarIcon'

export const CustomDatePicker = ({
  openTo = 'year',
  minDate = dayjs().subtract(75, 'years'),
  maxDate = dayjs(),
  forceShrink,
  ...props
}) => {
  const [isOpenCalendar, setIsOpenCalendar] = useState(false)
  const value = props.value ? (dayjs(props.value).isValid() ? dayjs(props.value) : null) : null
  const disable = !!props.disabled || !!props.readOnly

  const handleOpen = () => {
    if (disable) return
    setIsOpenCalendar(true)
  }

  const handleClose = () => setIsOpenCalendar(false)

  return (
    <DatePicker
      {...props}
      openTo={openTo}
      open={isOpenCalendar}
      onOpen={handleOpen}
      onClose={handleClose}
      minDate={props?.minDate ?? minDate}
      maxDate={props?.maxDate ?? maxDate}
      value={value}
      onChange={(date) => props.onChange?.(date ? date.toDate() : null)} // Convierte a `Date`
      slotProps={{
        textField: {
          onClick: handleOpen,
          readOnly: true,
          error: !isOpenCalendar && Boolean(props.error),
          helperText: !isOpenCalendar ? props.helperText : undefined,
          onBlur: () => props.onBlur?.({ target: { name: props.name } }),
          fullWidth: props.fullWidth,
          InputLabelProps: {
            shrink: forceShrink,
          },
        },
      }}
      slots={{
        openPickerIcon: () => <CustomSvgIcon svgString={calendarIcon} width="1.25rem" height="1.25rem" />,
        switchViewIcon: (props) => <KeyboardArrowDownIcon {...props} />,
      }}
    />
  )
}
